/**
 * Classick — Loop-stijl product-showcase kaarten.
 * Swatch-swap (kleur), maatkeuze en add-to-cart per kaart.
 */
(() => {
  if (window.__ckShowcaseInit) return;
  window.__ckShowcaseInit = true;

  const money = (cents, locale, currency) =>
    new Intl.NumberFormat(locale || 'nl', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);

  const colorDotBackground = (name = '') => {
    const color = name.toLowerCase();
    if (color.includes('flandrien') || color.includes('belgium')) {
      return 'linear-gradient(90deg, #111 0 33%, #f2d11f 33% 66%, #d52b2b 66%)';
    }
    if (color.includes('navy')) return '#26324a';
    if (color.includes('café') || color.includes('cafe') || color.includes('brown') || color.includes('bruin')) return '#6f4e37';
    if (color.includes('grey') || color.includes('gray') || color.includes('grijs')) return '#9a9a9a';
    if (color.includes('bordeau')) return '#5c1a2b';
    if (color.includes('red') || color.includes('rood')) return '#d4332c';
    if (color.includes('orange') || color.includes('oranje')) return '#ec6e2f';
    if (color.includes('yellow') || color.includes('geel')) return '#e8d449';
    if (color.includes('olive')) return '#72744c';
    if (color.includes('green') || color.includes('groen')) return '#3f785c';
    if (color.includes('turquoise') || color.includes('aqua')) return '#46a8aa';
    if (color.includes('mint')) return '#a7d7c8';
    if (color.includes('blue') || color.includes('blauw')) return '#3974ae';
    if (color.includes('purple') || color.includes('paars')) return '#745783';
    if (color.includes('pink') || color.includes('roze')) return '#d8839b';
    if (color.includes('beige') || color.includes('sand') || color.includes('cream')) return '#d9cfb8';
    if (color.includes('zwart') || color.includes('black')) return '#141414';
    if (color.includes('white') || color.includes('wit')) return '#fff';
    return '#d0d0d0';
  };

  const locale = document.documentElement.lang || 'nl';

  document.querySelectorAll('[data-ck-card]').forEach((card) => {
    const dataEl = card.querySelector('[data-ck-card-data]');
    if (!dataEl) return;
    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const colorways = data.colorways || [];
    const initialColorway = colorways.find((cw) => cw.id === Number(data.initialProductId)) || colorways[0];
    let current = initialColorway;
    let committed = initialColorway;
    let selectedVariant = null;

    const els = {
      media: card.querySelector('[data-ck-media]'),
      img: card.querySelector('.ck-card__img'),
      name: card.querySelector('[data-ck-name]'),
      colorLabel: card.querySelector('[data-ck-color]'),
      price: card.querySelector('[data-ck-price]'),
      sizes: card.querySelector('[data-ck-sizes]'),
      add: card.querySelector('[data-ck-add]'),
      buy: card.querySelector('[data-ck-buy]'),
      optionsLink: card.querySelector('[data-ck-options-link]'),
      error: card.querySelector('[data-ck-error]'),
    };
    let mobileColorSlider = null;

    if (card.closest('.ck-show--home') && colorways.length > 1 && els.media) {
      const orderedColorways = initialColorway
        ? [initialColorway, ...colorways.filter((colorway) => colorway.id !== initialColorway.id)]
        : colorways;
      const mediaWrap = document.createElement('div');
      mediaWrap.className = 'ck-card__mobile-media';

      const slider = document.createElement('div');
      slider.className = 'ck-card__mobile-color-slider';
      slider.setAttribute('role', 'region');
      slider.setAttribute('aria-label', 'Swipe voor andere kleuren');

      orderedColorways.forEach((colorway, index) => {
        const slide = document.createElement('a');
        slide.className = 'ck-card__mobile-color-slide';
        slide.href = colorway.url;
        slide.dataset.ckMobileColorway = colorway.id;
        slide.setAttribute('aria-label', `${els.name?.textContent?.trim() || 'Product'} in ${colorway.color}`);

        const image = document.createElement('img');
        image.src = colorway.image;
        image.alt = `${els.name?.textContent?.trim() || 'Product'} | ${colorway.color}`;
        image.loading = index === 0 ? 'eager' : 'lazy';
        slide.appendChild(image);
        slider.appendChild(slide);
      });

      const badge = els.media.querySelector('.ck-card__badge')?.cloneNode(true);
      const tag = els.media.querySelector('.ck-card__tag')?.cloneNode(true);
      const dots = document.createElement('div');
      dots.className = 'ck-card__mobile-dots';
      dots.setAttribute('aria-hidden', 'true');
      orderedColorways.forEach((colorway, index) => {
        const dot = document.createElement('span');
        dot.className = `ck-card__mobile-dot${index === 0 ? ' is-active' : ''}`;
        dot.style.setProperty('--sw', colorDotBackground(colorway.color));
        dots.appendChild(dot);
      });

      mediaWrap.appendChild(slider);
      if (badge) mediaWrap.appendChild(badge);
      if (tag) mediaWrap.appendChild(tag);
      mediaWrap.appendChild(dots);
      els.media.insertAdjacentElement('afterend', mediaWrap);
      card.classList.add('has-mobile-color-slider');
      mobileColorSlider = { slider, dots, colorways: orderedColorways, index: 0 };
    }
    const sizeOptionIndex = Number(data.sizeOptionIndex);
    const hasSizeOption = Number.isInteger(sizeOptionIndex) && sizeOptionIndex >= 0;
    const variantColorOptionIndex = Number(data.variantColorOptionIndex);
    const hasVariantColors = Number.isInteger(variantColorOptionIndex) && variantColorOptionIndex >= 0;
    let selectedColor = hasVariantColors
      ? initialColorway?.variants?.find((variant) => variant.available)?.options?.[variantColorOptionIndex]
      : null;

    /* ---------- swatches ---------- */
    const syncMobileSlider = (cw, smooth = false) => {
      if (!mobileColorSlider || !cw) return;
      const nextIndex = mobileColorSlider.colorways.findIndex((colorway) => colorway.id === cw.id);
      if (nextIndex < 0) return;
      mobileColorSlider.index = nextIndex;
      mobileColorSlider.dots.querySelectorAll('.ck-card__mobile-dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === nextIndex);
      });
      const targetLeft = nextIndex * mobileColorSlider.slider.clientWidth;
      if (Math.abs(mobileColorSlider.slider.scrollLeft - targetLeft) > 2) {
        mobileColorSlider.slider.scrollTo({ left: targetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }
    };

    const showColorway = (cw, { commit = false, preview = false, syncSlider = true } = {}) => {
      if (!cw) return;
      card.classList.toggle('is-previewing', preview);
      if (els.img && cw.image) {
        els.img.removeAttribute('srcset');
        els.img.removeAttribute('sizes');
        els.img.src = cw.image;
        els.img.alt = `${els.name?.textContent?.trim() || ''} | ${cw.color}`;
      }
      if (els.colorLabel) els.colorLabel.textContent = cw.color;
      if (!commit) return;
      current = cw;
      committed = cw;
      selectedVariant = null;
      if (hasVariantColors) {
        selectedColor = cw.variants?.find((variant) => variant.available)?.options?.[variantColorOptionIndex] || selectedColor;
      }

      card.querySelectorAll('[data-ck-swatch]').forEach((s) => {
        const isCurrent = Number(s.dataset.ckSwatch) === cw.id;
        s.classList.toggle('is-active', isCurrent);
        s.setAttribute('aria-pressed', String(isCurrent));
      });

      if (els.media) els.media.href = cw.url;
      if (els.name) els.name.href = cw.url;
      if (els.price) {
        const cmp = cw.compareAt && Number(cw.compareAt) > Number(cw.price)
          ? `<s>${money(cw.compareAt, locale)}</s>` : '';
        els.price.innerHTML = `${cmp}<strong>${money(cw.price, locale)}</strong>`;
      }
      if (hasSizeOption) renderSizes();
      if (syncSlider) syncMobileSlider(cw, true);
      hideError();
    };

    if (mobileColorSlider) {
      let scrollFrame = null;
      mobileColorSlider.slider.addEventListener('scroll', () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const slideWidth = mobileColorSlider.slider.clientWidth;
          if (!slideWidth) return;
          const nextIndex = Math.max(
            0,
            Math.min(mobileColorSlider.colorways.length - 1, Math.round(mobileColorSlider.slider.scrollLeft / slideWidth))
          );
          if (nextIndex === mobileColorSlider.index) return;
          mobileColorSlider.index = nextIndex;
          mobileColorSlider.dots.querySelectorAll('.ck-card__mobile-dot').forEach((dot, index) => {
            dot.classList.toggle('is-active', index === nextIndex);
          });
          showColorway(mobileColorSlider.colorways[nextIndex], { commit: true, syncSlider: false });
        });
      }, { passive: true });
    }

    card.querySelectorAll('[data-ck-swatch]').forEach((sw) => {
      const colorway = () => colorways.find((c) => c.id === Number(sw.dataset.ckSwatch));
      sw.addEventListener('pointerenter', () => showColorway(colorway(), { preview: true }));
      sw.addEventListener('focus', () => showColorway(colorway(), { preview: true }));
      sw.addEventListener('pointerleave', () => showColorway(committed));
      sw.addEventListener('blur', () => showColorway(committed));
      sw.addEventListener('click', () => showColorway(colorway(), { commit: true }));
    });

    card.querySelectorAll('[data-ck-variant-color]').forEach((sw) => {
      sw.addEventListener('click', () => {
        selectedColor = sw.dataset.ckVariantColor;
        selectedVariant = null;
        card.querySelectorAll('[data-ck-variant-color]').forEach((item) => {
          const isCurrent = item.dataset.ckVariantColor === selectedColor;
          item.classList.toggle('is-active', isCurrent);
          item.setAttribute('aria-pressed', String(isCurrent));
        });
        if (els.colorLabel) els.colorLabel.textContent = selectedColor;
        const firstAvailable = (current.variants || []).find((variant) =>
          variant.available && variant.options?.[variantColorOptionIndex] === selectedColor
        );
        if (firstAvailable) {
          const variantUrl = current.url + '?variant=' + firstAvailable.id;
          if (els.media) els.media.href = variantUrl;
          if (els.name) els.name.href = variantUrl;
        }
        if (hasSizeOption) renderSizes();
        hideError();
      });
    });

    /* ---------- sizes ---------- */
    function renderSizes() {
      if (!els.sizes || !hasSizeOption) return;
      els.sizes.innerHTML = '';
      const sizeGroups = new Map();
      (current.variants || []).forEach((variant) => {
        if (hasVariantColors && variant.options?.[variantColorOptionIndex] !== selectedColor) return;
        const size = variant.options?.[sizeOptionIndex];
        if (!size) return;
        const group = sizeGroups.get(size) || { available: false, variant: null };
        if (variant.available && !group.variant) group.variant = variant;
        group.available = group.available || variant.available;
        sizeGroups.set(size, group);
      });
      sizeGroups.forEach((group, size) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ck-card__size' + (group.available ? '' : ' is-soldout');
        button.textContent = size;
        button.dataset.ckSizeValue = size;
        if (!group.available) button.disabled = true;
        button.addEventListener('click', () => {
          selectedVariant = group.variant?.id || null;
          els.sizes.querySelectorAll('.ck-card__size').forEach((item) => item.classList.remove('is-selected'));
          button.classList.add('is-selected');
          if (els.optionsLink && selectedVariant) {
            els.optionsLink.href = current.url + '?variant=' + selectedVariant;
          }
          hideError();
        });
        els.sizes.appendChild(button);
      });
    }
    if (hasSizeOption) renderSizes();

    /* ---------- add to cart / buy now ---------- */
    function resolveVariant() {
      if (selectedVariant) return selectedVariant;
      const available = (current.variants || []).filter((variant) => {
        if (!variant.available) return false;
        if (!hasVariantColors) return true;
        return variant.options?.[variantColorOptionIndex] === selectedColor;
      });
      if (!hasSizeOption && available.length > 0) {
        selectedVariant = available[0].id;
        return selectedVariant;
      }
      if (available.length === 1) {
        selectedVariant = available[0].id;
        return selectedVariant;
      }
      showError('Kies eerst je maat.');
      return null;
    }

    async function addVariant(button, checkout) {
      const variantId = resolveVariant();
      if (!variantId) return;
      button.disabled = true;
      const label = button.textContent;
      button.textContent = checkout ? 'Doorsturen…' : 'Toevoegen…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Kon niet toevoegen.');
        if (checkout) {
          window.location.assign('/checkout');
          return;
        }
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: result, sourceId: 'ck-showcase', data: { source: 'product-form-component', itemCount: 1 } },
          })
        );
        button.textContent = 'Toegevoegd ✓';
        setTimeout(() => {
          button.textContent = label;
          button.disabled = false;
        }, 1800);
      } catch (error) {
        button.textContent = label;
        button.disabled = false;
        showError(error.message);
      }
    }

    els.add?.addEventListener('click', () => addVariant(els.add, false));
    els.buy?.addEventListener('click', () => addVariant(els.buy, true));

    function showError(m) {
      if (!els.error) return;
      els.error.textContent = m;
      els.error.hidden = false;
    }
    function hideError() {
      if (els.error) els.error.hidden = true;
    }
  });

  /* ---------- reviews.io: verberg fallback als echte rating laadt ---------- */
  const upgradeRatings = () => {
    document.querySelectorAll('[data-ck-card] .ck-card__rating').forEach((r) => {
      const real = r.querySelector('.ruk-rating-snippet-wrapper, [class*="ruk_rating"] .ruk-rating');
      if (real && real.textContent.trim()) {
        const fb = r.querySelector('.ck-card__rating-num');
        if (fb) fb.style.display = 'none';
      }
    });
  };
  setTimeout(upgradeRatings, 2500);
})();
